export default [
  {
    title: 'Tài khoản',
    group: 'apps',
    icon: 'account_circle',
    name: 'Profile',
    roleId: 0
  },
  // {
  //   title: 'Thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayOrderList',
  //   roleId: 2
  // },
  {
    title: 'Khách hàng', 
    icon: 'account_box',
    name: 'CustomerList', 
    roleId: 2,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail' }
    ]
  },
  // {
  //   title: 'Tracking',
  //   group: 'apps',
  //   icon: 'flight',
  //   name: 'Tracking',
  //   roleId: 0
  // },
  {
    title: 'Kiện hàng',
    group: 'apps',
    icon: 'widgets',
    name: 'StoreManager',
    roleId: 0
  },
  {
    title: 'Lô hàng',
    group: 'apps',
    icon: 'archive',
    name: 'BigPackage',
    roleId: 0
  },
  {
    title: 'Người dùng',
    group: 'apps',
    icon: 'group',
    name: 'StaffList',
    children: [
      { name: 'StaffDetail', title: 'Chi tiết người dùng', component: 'StaffDetail' }
    ],
    roleId: 1
  },
  {
    title: 'Thông báo',
    group: 'apps',
    icon: 'notifications_active',
    name: 'Notification',
    roleId: -1
  },
  {
    title: 'Tính cước',
    group: 'apps',
    icon: 'calculate',
    name: 'Calc',
    roleId: -1
  },
  {
    title: 'Hàng vô chủ',
    group: 'apps',
    icon: 'help_outline',
    name: 'NoneOwner',
    roleId: 0
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Setting',
    roleId: 1,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      },
      {
        title: 'Hạng khách hàng',
        name: 'LevelList',
        component: 'LevelList', 
        children: [
          { name: 'LevelDetail', title: 'Chi tiết hạng khách hàng', component: 'LevelDetail' }
        ]
      },
      {
        name: 'FeeWeightList', 
        title: 'Phí cân nặng', 
        component: 'FeeWeightList', 
        children: [
          { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
        ]
      },
      {
        name: 'FeeVolumeList', 
        title: 'Phí khối', 
        component: 'FeeVolumeList', 
        children: [
          { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
        ]
      },
    ]
  },
  // {
  //   title: 'Lịch sử thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayHistoryList',
  //   roleId: -1
  // }
];
